// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { user } = useAuth();
  const userRole = user?.role;
  const userPlan = user?.subscriptionPlan;

  // Filter menu items by role and subscription plan
  const filteredItems = menuItem.items.map((group) => {
    // Filter entire groups by role
    if (group.roles && !group.roles.includes(userRole)) {
      return null;
    }

    // Filter entire groups by plan
    if (group.plans && !group.plans.includes(userPlan)) {
      // SUPER_ADMIN always sees everything
      if (userRole !== 'SUPER_ADMIN') return null;
    }

    if (!group.children) return group;
    const filteredChildren = group.children.filter((item) => {
      // Role filter
      if (item.roles && !item.roles.includes(userRole)) return false;
      // Plan filter on individual items
      if (item.plans && !item.plans.includes(userPlan) && userRole !== 'SUPER_ADMIN') return false;
      return true;
    });
    if (filteredChildren.length === 0) return null;
    return { ...group, children: filteredChildren };
  }).filter(Boolean);

  const navGroups = filteredItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
